import { createSlice } from "@reduxjs/toolkit";

const menuTypeSlice = createSlice({
    name: "menuType",
    initialState: "research",
    reducers: {
        setMenuType: (state, action) => action.payload,
    },
});

export const { setMenuType } = menuTypeSlice.actions;
export default menuTypeSlice.reducer;